import { useFeatureFlag } from 'utils/hooks/useFeatureFlag';
import { CAT_IN_SEG_QB_V2_FEATURE_FLAG } from '../featureFlags';

export const useCatInSegQueryBuilderV2FeatureFlag = () =>
  useFeatureFlag(CAT_IN_SEG_QB_V2_FEATURE_FLAG);
